module.exports = __webpack_public_path__ + "img/diwen.edbc80a9.png";